module.exports = __webpack_public_path__ + "static/media/Slice4.aeb4268b.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_151/img/Slice4.png
// module id = 1485
// module chunks = 0